export default {
  async created() {
    window.addEventListener("online", async () => {
      const requests = this.$store.state.requests
      try {
        if (!requests || !requests.length) return

        await this.syncServer(requests)

        this.$swal().success("Seus dados foram sincronizados com sucesso!")
      } catch (err) {
        this.$swal().error(
          `Surgiram alguns erros ao sincronizar dados! \n ${err}`
        )
      }
    })
  },
  methods: {
    async updateCache(uuid, { data }) {
      let requests = JSON.parse(localStorage.getItem("requests"))
      requests = requests.map(el => {
        if (el.data.uuid == uuid && el.method.toLowerCase() == "patch") {
          if (el.url.match(/route-items\/.+/g).length) {
            el.url = el.url.replace(/\/.+/g, `/${data.id}`)
          }
        }
        el.data.id = data.id

        return el
      })

      localStorage.setItem("requests", JSON.stringify(requests))
    },
    async request(paylod, vuex) {
      const response = await this.$http.request(paylod)
      if (vuex.type == "create") {
        await this.updateCache(paylod.data.uuid, response)
      }

      // Essta função está em um mixxin global
      this.updateStores(vuex, paylod.data.uuid, response)

      return paylod.id
    },
    removeRequests(cache, removeRequests) {
      const newCache = []
      for (const index in cache) {
        if (!removeRequests.includes(cache[index].id)) {
          newCache.push(cache[index])
        }
      }

      cache = newCache

      this.$store.commit("updateStorage", cache)
    },
    async syncServer(cache) {
      const errorList = []
      const removeRequests = []
      for (const index in cache) {
        const storage = JSON.parse(localStorage.getItem("requests"))
        const { vuex, ...paylod } = storage[index]
        try {
          const id = await this.request(paylod, vuex)

          removeRequests.push(id)
        } catch (err) {
          await this.handleError(err)
          errorList.push(
            `O.S: ${paylod?.data?.id || ""} - ${err.response.data.message}`
          )
        }
      }

      this.removeRequests(cache, removeRequests)

      if (errorList.length) {
        throw errorList.toString()
      }
      Promise.resolve(true)
    },
    async handleError(err) {
      alert(err.response || err || "Error ao sincronizar dados")
    },
  },
}
